module.exports = __webpack_public_path__ + "img/t2-blue.7418745f.png";